module.exports = "<p>\n  home-welcome works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home-welcome/home-welcome.component.html
// module id = ./src/app/components/home/home-welcome/home-welcome.component.html
// module chunks = main